import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { AuthenticatedPage } from '../components/AuthenticatedPage';
import { CareerReadinessAssessment } from '../components/CareerReadiness/CareerReadinessAssessment';
import { CareerReadinessHeader } from '../components/CareerReadiness/CareerReadinessHeader';
import { ProficiencyRatingScale } from '../components/CareerReadiness/ProficiencyRatingScale';
import Container from '../components/container/Container';
import { usePreEmploymentAssessmentContext } from '../hooks/use-pre-employment-assessment.hooks';
import { useSWOTContext } from '../hooks/use-swot-context.hooks';
import { dispatchGetCareerReadinessValues } from '../redux/slice/form-career-readiness';
import {
  PreEmploymentAssessmentStatus,
  dispatchUpsertPreEmploymentAssessment,
} from '../redux/slice/pre-employment-assessment';
import { dispatchGetSWOTReportValues } from '../redux/slice/swot/swot.operations';
import { SWOTReport } from '../redux/slice/swot/swot.types';
import { useAppDispatch } from '../redux/store';

export const CareerReadiness: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const swot: SWOTReport | undefined = useSWOTContext();
  const { componentName } = useParams();
  const { status: preEmploymentAssessmentStatus } = usePreEmploymentAssessmentContext();

  useEffect(() => {
    void dispatch(dispatchGetCareerReadinessValues());
    void dispatch(dispatchUpsertPreEmploymentAssessment());
    void dispatch(dispatchGetSWOTReportValues());
  }, []);

  const [step, setStep] = useState(1);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleBackButton = () => {
    if (step == 1) {
      navigate('/pre-employment/skills/step11');
    } else {
      navigate(`/pre-employment/career-readiness/step${step - 1}`);
    }
  };

  useEffect(() => {
    setStep(parseInt(componentName?.replace('step', '') || '1'));
    window.scrollTo(0, 0);
  }, [componentName]);

  useEffect(() => {
    if (preEmploymentAssessmentStatus === PreEmploymentAssessmentStatus.NOT_STARTED) {
      void dispatch(
        dispatchUpsertPreEmploymentAssessment({
          status: PreEmploymentAssessmentStatus.ACTIVE,
        }),
      );
    }
  }, [preEmploymentAssessmentStatus]);

  useEffect(() => {
    if (swot) {
      navigate('/swot');
    }
  }, [swot, navigate]);

  const renderFormStep = () => {
    switch (componentName) {
      case 'step1':
        return <CareerReadinessAssessment step={step} onBack={handleBackButton} />;
      case 'step2':
        return <ProficiencyRatingScale step={step} onBack={handleBackButton} />;
      default:
        navigate('/pre-employment/career-readiness/step1');
        return null;
    }
  };

  return (
    <div className={`steps overflow-hidden relative career-${step}`}>
      <Container>
        <>
          <CareerReadinessHeader>
            <>{renderFormStep()}</>
          </CareerReadinessHeader>
        </>
      </Container>
    </div>
  );
};

export const CareerReadinessPage: React.FC = () => {
  return <AuthenticatedPage render={() => <CareerReadiness />} />;
};
